import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-xl border-2 border-ud-orange-25 bg-ud-g5 px-3 py-2 text-base text-ud-g1 ring-offset-ud-g5 file:border-0 file:bg-transparent file:text-sm file:font-medium file:dark:text-ud-g5 file:text-ud-g1 placeholder:text-ud-g1/50 focus-visible:outline-hidden focus-visible:border-ud-orange/100 disabled:cursor-not-allowed disabled:opacity-50 dark:border-ud-dm-orange-25 dark:bg-ud-g1 dark:text-ud-g5 dark:ring-offset-ud-g1 dark:placeholder:text-ud-g5/50 dark:focus-visible:border-ud-dm-orange/100",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }